module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "_header"
  }, [_c('div', {
    staticClass: "user-info"
  }, [_c('div', {
    staticClass: "right",
    on: {
      "click": function($event) {
        _vm.$router.go({
          name: 'me-edit'
        })
      }
    }
  }, [_vm._v("\n                编辑\n                "), _c('div', {
    staticClass: "arrow-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "avatar"
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('BottomBar', {
    attrs: {
      "index": 2
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h2', [_vm._v("微信昵称")]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v("\n                    ID: 1000000\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menus"
  }, [_c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "arrow-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n                用药设置提醒\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "arrow-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n                日常血糖检测记录\n            ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4032eb91!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/me.vue
// module id = 251
// module chunks = 1